import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { GlobalPriceChartService } from "./global-price-chart.service";
import { GlobalPriceChartController } from "./global-price-chart.controller";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { GlobalPriceChart } from "./global-price-chart.entity";
import { GlobalPriceChartLog } from "./global-price-chart-log.entity";

@Module({
    imports: [
         TypeOrmModule.forFeature([GlobalPriceChart,GlobalPriceChartLog]),
    ],
    controllers: [GlobalPriceChartController],
    providers: [GlobalPriceChartService,ApplicationExceptionHandler],
    exports: [GlobalPriceChartService],
  })
  export class GlobalPriceChartModule {}

